import React from "react";

import UseCasesPageTemplate from "../../components/global/layout/UseCasesPageTemplate";
import { optimisation } from "../../constants/productPageData";
import { mediaQueries } from "../../constants/mediaQueries";

const Billing = ({ location }) => {
    const imageSettings = [
        {
            id: 1,
            location: "right",
            coloursObj: {
                triangleColour: "#F59E0B",
                backgroundColor: "#FCD34D",
            },
            trianglePosition: "bottom-right",
            axisMultipliers: {
                x: 0.3,
                y: 0.1,
            },
        }, {
            id: 2,
            location: "left",
            coloursObj: {
                triangleColour: "#6EE7B7",
                backgroundColor: "#10B981",
            },
            trianglePosition: "top-right",
            axisMultipliers: {
                x: 0.1,
                y: 0.4,
            },
            styles: {
                position: "absolute",
                maxWidth: "1199px",
                top: 80,
                right: 0,

                [mediaQueries.isTabletLandscape]: {
                    top: 20,
                    right: 0,
                }
            },
        }, {
            id: 3,
            location: "right",
            coloursObj: {
                triangleColour: "#3B82F6",
                backgroundColor: "#1D4ED8",
            },
            trianglePosition: "bottom-left",
            axisMultipliers: {
                x: 0.3,
                y: 0.4,
            },
        }
    ]

    return (
        <UseCasesPageTemplate
            page={optimisation}
            theme="blue"
            imageSettings={imageSettings}
            location={location}
        />
    )
}

export default Billing